import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getCreateAudioHref,
  getDeleteSongAudioHref,
  getDownloadAudioHref,
  getGroupedAudioList,
  getSong,
  getSongAudioTypes,
  getSongAudioValidations,
  getSongAudioList,
} from 'app/store/SongList/selectors';
import {
  fetchSongAudioListEffect,
  fetchSongAudioTypesEffect,
  fetchSongAudioValidationsEffect,
} from 'app/store/SongList/effects';
import { useResource } from 'app/utils/hooks';
import { getSharedLinksLink } from 'app/store/Shares/selectors';
import { saveAudioListReadyForUpload } from 'app/store/SongList/slice';
import { AudioListComponent } from './AudioListComponent';

export const AudioList = () => {
  const dispatch = useAppDispatch();
  const song = useAppSelector(
    getSong,
    (prev, next) => prev?.guid === next?.guid
  );
  const createAudioHref = useAppSelector(getCreateAudioHref);
  const downloadAudioHref = useAppSelector(getDownloadAudioHref);
  const deleteAudioHref = useAppSelector(getDeleteSongAudioHref);
  const shareAudioLink = useAppSelector(getSharedLinksLink);
  const [audioTypes, audioTypesLoading] = useResource(
    fetchSongAudioTypesEffect,
    getSongAudioTypes
  );

  const [, audioListLoading] = useResource(
    fetchSongAudioListEffect,
    getSongAudioList,
    { useCache: false }
  );

  const [audioValidations, audioValidationsLoading] = useResource(
    fetchSongAudioValidationsEffect,
    getSongAudioValidations,
    {
      shouldFetch: Boolean(createAudioHref),
    }
  );

  const groupedAudioList = useAppSelector(getGroupedAudioList);

  const loading =
    audioValidationsLoading || audioListLoading || audioTypesLoading;

  useEffect(
    () =>
      function unmount() {
        dispatch(saveAudioListReadyForUpload());
      },
    [dispatch]
  );

  return (
    <AudioListComponent
      loading={loading}
      dispatch={dispatch}
      createAudioHref={createAudioHref}
      downloadAudioHref={downloadAudioHref}
      deleteAudioHref={deleteAudioHref}
      audioFormValidation={audioValidations}
      audioList={groupedAudioList}
      audioTypes={audioTypes || {}}
      isShareAudioEnabled={Boolean(shareAudioLink?.href)}
      song={song}
    />
  );
};
